import script from "./FlowsReports.vue?vue&type=script&lang=ts&setup=true"
export * from "./FlowsReports.vue?vue&type=script&lang=ts&setup=true"

import "./FlowsReports.vue?vue&type=style&index=0&id=1db14b5c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1db14b5c"]])

export default __exports__